<template>
  <v-expansion-panel>
    <v-expansion-panel-header v-slot="{ open }" :color="inputColor" v-bind:class="{archived: relation.isDeleted}">
      <div class="d-flex justify-space-between">
        <div>
          <span class="font-weight-bold" v-if="relation.isDeleted">[ARCHIVED]</span> Deliverable to {{ relation.workPackage.title }}
        </div>
        <div v-if="canSendDeliverable || canReceiveRelation" class="pr-5">
          <v-fade-transition v-if="canSendDeliverable" hide-on-leave leave-absolute>
            <v-btn v-if="open" outlined small @click.stop="onClickMarkAsSent">mark
              as sent
            </v-btn>
          </v-fade-transition>

          <v-fade-transition v-if="canReceiveRelation" hide-on-leave leave-absolute>
            <v-btn v-if="open" class="ml-2" outlined small
                   @click.stop="onClickMarkAsReceived">mark as
              received
            </v-btn>
          </v-fade-transition>
        </div>
      </div>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <relation-log-table :relation="relation"/>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import CreateLogEntry from '@/modules/project-management/graphql/CreateLogEntry.graphql';
import {aggregateStatus, getFlatColor} from "@/utils/status";
import RelationLogTable from "@/modules/project-management/components/relation/RelationLogTable";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "IssueListItemRelationListItem",
  components: {RelationLogTable},
  props: {
    relation: Object,
    hasRights: Boolean
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('workPackage', {
      findWorkPackage: 'find'
    }),
    inputColor() {
      return getFlatColor(aggregateStatus(this.relation.status));
    },
    canSendDeliverable() {
      return this.relation.status.hasOwnProperty('awaiting-sent') && this.hasRights;
    },
    canReceiveRelation() {
      let wp = this.findWorkPackage(this.relation.workPackage.id);
      return this.relation.status.hasOwnProperty('awaiting-received') &&
        this.user?.memberships?.filter(m => m.team === wp.team.id).length >= 1;
    },

  },
  methods: {

    /////
    // Other
    /////
    generateInputColor(input) {
      return getFlatColor(aggregateStatus(input.status));
    },

    /////
    // Actions
    /////
    onClickMarkAsSent() {
      this.$apollo.mutate({
        mutation: CreateLogEntry,
        variables: {
          action: 'sent',
          relation: this.relation['id']
        }
      }).then(value => {
        this.$emit('update');
      })
    },
    onClickMarkAsReceived() {
      this.$apollo.mutate({
        mutation: CreateLogEntry,
        variables: {
          action: 'received',
          relation: this.relation['id']
        }
      }).then(value => {
        this.$emit('update');
      })
    }
  }
}
</script>

<style scoped>
.archived {
  opacity: 0.4;
}
</style>
